import moment from 'moment';

export const customerAccountDetailFilterState = () => ({
  page: 1,
  perPage: 10,
  year: (moment().year() - 1).toString()
});
